module.exports = __webpack_public_path__ + "img/www.greatschools.org.06cb062c.png";